import React from "react";
import { useParams, Navigate } from "react-router-dom";
import Newnabar from "../components/shared/Newnabar";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";
import SEO from "../components/shared/SEO";
import { getBlogPostBySlug } from "../components/data/blogPosts";
import BlogPostHero from "../components/blog-post/BlogPostHero";
import BlogPostBody from "../components/blog-post/BlogPostBody";
import BlogPostSidebar from "../components/blog-post/BlogPostSidebar";
import BlogPostShare from "../components/blog-post/BlogPostShare";
import BlogPostRelated from "../components/blog-post/BlogPostRelated";
import WriteYourOwnBlog from "../components/blog-post/WriteYourOwnBlog";
import BlogPostNewsletter from "../components/blog-post/BlogPostNewsletter";

export default function BlogPost() {
  const { slug } = useParams();
  const post = getBlogPostBySlug(slug);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden bg-white pt-16">
      <SEO
        title={`${post.title} | SoloConnect Blog`}
        description={post.excerpt}
        keywords={`${post.tag}, solo travel blog, travel guide, ${post.title}`}
      />
      <Newnabar />

      <main className="flex-grow bg-white">
        <BlogPostHero post={post} />

        <div className="block sm:hidden max-w-[1200px] mx-auto px-6 pt-6">
          <BlogPostShare />
        </div>

        <section className="max-w-[1200px] mx-auto px-6 pt-6 pb-12 sm:py-12 lg:py-16 grid grid-cols-1 lg:grid-cols-[1fr_360px] gap-12 lg:gap-16 items-start">
          <div className="w-full min-w-0">
            <BlogPostBody post={post} />
          </div>
          <div className="w-full">
            <BlogPostSidebar currentSlug={post.slug} />
          </div>
        </section>

        <BlogPostRelated currentSlug={post.slug} />
        <WriteYourOwnBlog />
        <BlogPostNewsletter />
      </main>

      <div className="hidden md:block">
        <SoloConnectFooter />
      </div>

      <div className="block md:hidden">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
